export default function () {
  let window = `relatorio.leiloes.prestacaoContas`
  !this.$uloc.window.get(window) && this.$uloc.window.new({
    wid: window,
    title: 'Prestação de Contas de Leilão',
    width: '600',
    height: '360',
    minHeight: '360px',
    backdrop: false,
    maximize: false,
    clickOutside: false,
    windowClass: 'erp-window',
    contentClass: 'overflow-hidden',
    props: {
    }
  }, () => import('./PrestacaoContas.vue'))
    .then((wid) => {
      console.log(wid)
    }) // return wid
}
